import {
    Button,
    ButtonColorAgainst,
    ButtonSize,
    ButtonVariant
} from "../../../../libraries/design/components/button/src/button.tsx";

export type UniformButtonProps = {
    text: string;
    href: string;
    size?: ButtonSize;
    variant?: ButtonVariant;
    colorAgainst?: ButtonColorAgainst;
};

const UniformButton = (props: UniformButtonProps) => {
    return (
        <Button
            {...props}
            dataEventProps={{
                "data-product-key": "uniform",
                "data-event-component": "linkButton",
                "data-event-container": "button",
                "data-event": "clicked"
            }}
        >
            {props.text}
        </Button>
    );
};

export default UniformButton;
